import { post } from "./helper_api"
import * as url from "./helper_path"


const createPassagerAPI = params => post(url.CREATE_PASSAGER,params).catch(err => err);

export {
  createPassagerAPI
}
